/* eslint-disable max-lines-per-function */
import React from 'react';
import { RadioButton } from 'primereact/radiobutton';
import Boleto from '../../assets/boleto.png';
import ContaEnergia from '../../assets/conta_energia.png';
import Pix from '../../assets/pix.png';
import { Field } from 'formik';
import Bandeiras from '../bandeiras';
import './AceiteEletronicoEnvio.css';

export default function AceiteEletronicoEnvio({ envio, setEnvio, tipoCob, adesaoPaga }) {
    const ImagensDeEnvio = adesaoPaga ? 'adesaoPaga' : (() => {
        switch (tipoCob) {
            case 8:
                return 'escelsa';
            case 7:
                return 'comPix';
            case 5:
                return 'debitoEmConta';
            default:
                return 'semPix';
        }
    })();
    const ComponentesDeImagem = {
        semPix: (
            <div className='TipoAceite'>
                <div className="boleto p-field-checkbox p-col-12 p-md-6 p-lg-4 p-sm-12">
                    <div className="p-field p-grid p-field-grid">
                        <img
                            alt="boleto"
                            src={Boleto}
                            className="boleto-img"
                        />
                    </div>
                    <div className="p-field p-grid">
                        <Field
                            as={RadioButton}
                            inputId="aceite"
                            name="aceite"
                            value={1}
                            onChange={e => setEnvio(e.value)}
                            checked={envio === 1}
                        />
                        <label htmlFor="aceite">Aceite</label>
                    </div>
                </div>

                <div className="cartoes p-field-checkbox p-col-12 p-md-6 p-lg-4 p-sm-12">
                    <div className="p-field p-grid" style={{
                        marginBottom: '14px',
                        marginTop: '7px'
                    }}>
                        <Bandeiras />
                    </div>
                    <div className="p-field p-grid">
                        <Field
                            as={RadioButton}
                            inputId="adesao"
                            name="adesao"
                            value={2}
                            onChange={e => setEnvio(e.value)}
                            checked={envio === 2}
                        />
                        <label htmlFor="adesao">Aceite e adesão</label>
                    </div>
                </div>
            </div>
        ),
        comPix: (
            <div className='TipoAceite'>
                <div className="p-field-checkbox p-col-12 p-md-6 p-lg-6 p-sm-12">
                    <div className="p-field p-grid">
                        <Bandeiras />
                    </div>
                    <div className="p-field p-grid">
                        <Field
                            as={RadioButton}
                            inputId="recorrencia"
                            name="recorrencia"
                            value={3}
                            onChange={e => setEnvio(e.value)}
                            checked={envio === 3}
                        />
                        <label htmlFor="recorrencia">Aceite, adesão e recorrência</label>
                    </div>
                </div>

                <div className="p-field-checkbox p-col-12 p-md-6 p-lg-6 p-sm-12">
                    <div className="p-field p-grid">
                        <img className="pix-img" alt="pix" src={Pix} />
                    </div>
                    <div className="p-field p-grid">
                        <Field
                            as={RadioButton}
                            inputId="pix-e-recorrencia"
                            name="pix-e-recorrencia"
                            value={5}
                            onChange={e => setEnvio(e.value)}
                            checked={envio === 5}
                        />
                        <label htmlFor="recorrencia">Aceite, adesão com pix e recorrência no cartão</label>
                    </div>
                </div>
            </div>
        ),
        debitoEmConta: (
            <div className='TipoAceite'>
                <div className="p-field-checkbox p-col-12 p-md-6 p-lg-4 p-sm-3">
                    <div>
                        <img alt="pix" src={Pix} className="pix-img" />
                    </div>
                    <div className="p-field p-grid">
                        <Field
                            as={RadioButton}
                            inputId="debito-em-conta-pix"
                            name="debito-em-conta-pix"
                            value={6}
                            onChange={e => setEnvio(e.value)}
                            checked={envio === 6}
                        />
                        <label htmlFor="debitoEmConta">Aceite, adesão PIX, recorrência débito em conta</label>
                    </div>
                </div>
            </div>
        ),
        adesaoPaga: (
            <div className='TipoAceite'>
                <div className="boleto p-field-checkbox p-col-12 p-md-6 p-lg-4 p-sm-12">
                    <div className="p-field p-grid p-field-grid">
                        <img alt="boleto" src={Boleto} className="boleto-img" />
                    </div>
                    <div className="p-field p-grid">
                        <Field
                            as={RadioButton}
                            inputId="aceite"
                            name="aceite"
                            value={1}
                            onChange={e => setEnvio(e.value)}
                            checked={envio === 1}
                        />
                        <label htmlFor="aceite">Aceite</label>
                    </div>
                </div>
                <div className="p-field-checkbox p-col-12 p-md-6 p-lg-6 p-sm-12">
                    <div className="p-field p-grid">
                        <Bandeiras />
                    </div>
                    <div className="p-field p-grid">
                        <Field
                            as={RadioButton}
                            inputId="recorrencia"
                            name="recorrencia"
                            value={3}
                            onChange={e => setEnvio(e.value)}
                            checked={envio === 3}
                        />
                        <label htmlFor="recorrencia">Aceite e recorrência</label>
                    </div>
                </div>
            </div>
        ),
        escelsa: (
            <div className='TipoAceite'>
                <div className="p-field-checkbox p-col-12 p-md-6 p-lg-4 p-sm-12">
                    <div className="p-field p-grid p-field-grid">
                        <img
                            alt="energia"
                            src={ContaEnergia}
                            className="energia-img"
                        />
                    </div>
                    <div className="p-field p-grid">
                        <Field
                            as={RadioButton}
                            inputId="aceite"
                            name="aceite"
                            value={1}
                            onChange={e => setEnvio(e.value)}
                            checked={envio === 1}
                        />
                        <label htmlFor="aceite">Aceite</label>
                    </div>
                </div>

                <div className="cartoes p-field-checkbox p-col-12 p-md-6 p-lg-4 p-sm-12">
                    <div className="p-field p-grid" style={{
                        marginBottom: '14px',
                        marginTop: '7px'
                    }}>
                        <Bandeiras />
                    </div>
                    <div className="p-field p-grid">
                        <Field
                            as={RadioButton}
                            inputId="adesao"
                            name="adesao"
                            value={2}
                            onChange={e => setEnvio(e.value)}
                            checked={envio === 2}
                        />
                        <label htmlFor="adesao">Aceite e adesão</label>
                    </div>
                </div>
            </div>
        )
    };

    return <>
        {ComponentesDeImagem[ImagensDeEnvio]}
    </>;
}
